import { useCallback, useEffect, useMemo, useState } from "react";
import { post } from "../networking/RequestService";

function useGetLinkedInContactsWithUser(params = {}, autoFetch = true) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const memoizedParams = useMemo(() => params, [JSON.stringify(params)]);

    const fetchGetLinkedInContacts = useCallback(async () => {
        if (!loading) setLoading(true);
        setError(null);
        try {
            const response = await post({ fn: "getLinkedInContactsWithUser", ...memoizedParams });
            setData(response.data.data);
        } catch (error) {
            setError(error.response?.data?.text || "An unexpected error occurred");
        } finally {
            setLoading(false);
        }
    }, [memoizedParams]);

    useEffect(() => {
        if (autoFetch) {
            fetchGetLinkedInContacts();
        }
    }, [fetchGetLinkedInContacts, autoFetch]);

    return { data, loading, error, fetchGetLinkedInContacts };
}

export default useGetLinkedInContactsWithUser;
